import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import {Draw, Modify, Snap} from "ol/interaction";
import {getBookmarkPresentationsByID, removeLayer} from "@/helpers/ol/ol-layer-helper";
import {
    geMeasureLayerName, generateMeasureLayers,
    getMeasureLayerStyleFunction,
    getMeasureModifyStyle, getToolsMeasureStyle, setActiveMeasureFeatureKey
} from "@/helpers/tools/tools-measure-helper";
import {Fill, Stroke, Style, Text} from "ol/style";
import {
    getMutationFeatureInfo,
    getMutationLayerName, inactiveMutationGeometryButton,
    setActiveMutationGeometry
} from "@/helpers/tools/tools-mutation-helper";
import {initDataTableStandAloneEditor} from "@/helpers/datatable/datatable-standalone-editor-helper";
import {
    generateDataTableItem,
    generateDataTableItemAttributes, generateDataTableMutationAttributes
} from "@/components/layer/info/info/layer-info-info-item-component";
import {
    getActiveFilter,
    getBookmarkPresentationByActiveFilter,
    getFilterLayerName
} from "@/helpers/filter/filter-helper";
import {clearFilterSelectLayer} from "@/helpers/filter/filter-geometry-helper";
import {
    disableElementsBySelector, enableElementsBySelector,
    getAllBySelector,
    getBySelector,
    hideElementsBySelector,
    showElementsBySelector
} from "@/helpers/element-helper";
import {
    checkActiveLayerInfoButtons,
    hideAllInfo,
    hideLayerInfoForm,
    showLayerInfoButton
} from "@/helpers/layer/info/layer-info-helper";
import {finishMutationDrawing} from "@/helpers/datatable/datatable-editor-helper";
import {getViewProjection} from "@/helpers/ol/ol-projection-helper";
import {deselectFeature} from "@/modules/ol/service/ol-service-wfs";
import {createBufferByGeometry} from "@/helpers/measure/measure-buffer-helper.js";
import {checkApplyButton, toggleApplyButtonDisabled} from "@/helpers/filter/filter-settings-helper.js";
import {isMobile} from "@/helpers/mobile-helper.js";
import {hideHeaderElement} from "@/helpers/header-helper.js";

let olDraw
let modify
let drawActive = false

// https://openlayers.org/en/latest/examples/measure-style.html

export function startDraw(name = 'draw', type = 'Polygon', geometryFunction = undefined, clickElement = null, isClearDraw = false, style = undefined, text = undefined) {

    if(isMobile(true)) {
        hideLayerInfoForm()
        hideHeaderElement('layer-menu')
    }

    if(drawActive) {
        if(isClearDraw) {
            clearDraw()
        }
        stopDraw()
        drawActive = false
        return
    }

    window.source = new VectorSource({
            wrapX: false
    });

    let vector
    if(name === geMeasureLayerName()) {
        if(window.drawMeasureVectorSource) {
            source = window.drawMeasureVectorSource
        } else {
            vector =  new VectorLayer({
                zIndex: 1000,
                altitudeMode: 'clampToGround',
                name: name,
                source: source,
                style: function (feature) {
                    if(feature.get('text')) {
                        style.getText().setText(feature.get('text'));
                        return style
                    } else {
                        return getMeasureLayerStyleFunction(feature, true);
                    }
                },
                properties: {
                    projection: 'EPSG:28992'
                }
            });
            window.drawMeasureVectorSource = source
            window.drawMeasureVectorLayer = vector
            window.map.addLayer(vector)
        }

        olDraw = new Draw({
            source: source,
            type: type,
            geometryFunction: geometryFunction,
            style: function (feature) {
                // return style
                return getMeasureLayerStyleFunction(
                    feature,
                    true,
                    type,
                    'Klik in de kaart om een punt te plaats en dubbelklik om de tekening te voltooien'
                );
            },
        });

        modify = new Modify({source: source, style: getMeasureModifyStyle()});
        modify.on('modifyend', () => {
            generateMeasureLayers()
        })
        modify.on('propertychange', () => {
            generateMeasureLayers()
        })
        window.map.addInteraction(modify);

        // TODO: add snap
        // const snap = new Snap({
        //     source: source,
        // });
        // window.map.addInteraction(snap);
        // snap.on('snap', function (e) {});
    } else {
        vector = new VectorLayer({
            altitudeMode: 'clampToGround',
            name: name,
            source: source,
            style: style,
            zIndex: 1000
        });
        window.map.addLayer(vector)

        olDraw = new Draw({
            source: source,
            type: type,
            geometryFunction: geometryFunction,
            style: style
        });
    }

    if(name === getFilterLayerName()) {
        hideElementsBySelector('.circle-radius')
        olDraw.on('drawstart', function (event) {
            disableElementsBySelector('.circle-radius-input')
            if(type === 'Circle' && !geometryFunction) {
                showElementsBySelector('.circle-radius')
            }

            const geometry = event.feature.getGeometry();
            geometry.on('change', function () {

                console.log('changeee')

                const coords = geometry.getCoordinates();
                switch (geometry.getType()) {
                    case 'Polygon':
                        if(coords[0].length <= 4) {
                            disableElementsBySelector('button[data-type="save"]')
                        } else {
                            enableElementsBySelector('button[data-type="save"]')
                        }
                        break;
                    case 'LineString':
                        if(coords.length <= 2) {
                            disableElementsBySelector('button[data-type="save"]')
                        } else {
                            enableElementsBySelector('button[data-type="save"]')
                        }
                        break;
                    case 'Circle':

                        getAllBySelector('.circle-radius-input').forEach((input) => {
                            input.value = geometry.getRadius().toFixed(0)
                        })
                        break;
                }
            });
        });
    }

    window.map.addInteraction(olDraw);

    drawActive = true

    olDraw.on('drawend', function(evt){
        if(text) {
            evt.feature.set('text', text)
        }
        if(name === geMeasureLayerName()) {

            showElementsBySelector('layer-info-tools .btnCloseInfoMenu')

            evt.feature.set('key', window.drawMeasureVectorSource.getFeatures().length)
            evt.feature.set('style', {...getToolsMeasureStyle()})

            setTimeout(() => {
                if(window.drawMeasureVectorSource.getFeatures().length > 0) {
                    showElementsBySelector('layer-info-tools .btnHideInfoMenu')
                }
            }, 0)
        }

        const feature = evt.feature.clone()

        if(name === getFilterLayerName() && type === 'LineString') {
            feature.setGeometry(createBufferByGeometry(feature.getGeometry(), 1))
        }

        let projection = getViewProjection()
        const bookmarkPresentation = getBookmarkPresentationByActiveFilter()
        if(bookmarkPresentation) {
            projection = bookmarkPresentation.Service.Projection
        }


        setDrawGeometry(feature, undefined, projection)

        if(name !== geMeasureLayerName()) {
            stopDraw(true)
        }

        if(clickElement) {
            // clickElement.classList.remove('active')
        }

        if(name === getMutationLayerName()) {
            finishMutationDrawing(feature)
        }

        if(name === geMeasureLayerName()) {
            const length = window.drawMeasureVectorSource.getFeatures().length
            setActiveMeasureFeatureKey(length)
            generateMeasureLayers(false, length)
        }

        setTimeout(() => {

            checkActiveLayerInfoButtons()
        }, 300)

        checkApplyButton()
        hideElementsBySelector('#divFilterToolsMeasureDrawButtons')
        hideElementsBySelector('#divFilterToolsMeasureDrawButtonsMobile')

        if(name === getFilterLayerName()) {
            setTimeout(() => {
                if(isMobile(true)) {
                    showLayerInfoButton('layer-info-filter')
                    showElementsBySelector('layer-info-filter .btnHideInfoMenu')
                }
            }, 1000)
        }

        toggleApplyButtonDisabled(false)

        const geometry = feature.getGeometry()
        if(geometry.getType() === 'Circle') {
            getAllBySelector('.circle-radius-input').forEach((input) => {
                input.value = evt.feature.getGeometry().getRadius().toFixed(0)
            })
            enableElementsBySelector('.circle-radius-input')
        }
    });
}

export function clearDraw(name = 'draw') {
    removeLayer(name, false)
}
export function stopDraw(withTimeOut = false, clearFilterSelect = true) {

    if(withTimeOut) {
        setTimeout(() => {
            window.map.removeInteraction(olDraw)
            window.map.removeInteraction(modify);
            drawActive = false
        }, 300)
    } else {
        window.map.removeInteraction(olDraw)
        window.map.removeInteraction(modify);
        drawActive = false
    }
    if(clearFilterSelect) {
        clearFilterSelectLayer()
    }
}

export function isDrawActive() {
    return drawActive
}

export function updateDrawStyle(style) {
}


export function setDrawGeometry(feature, projectionFrom, projectionTo = 'EPSG:28992', geometry, type) {
    if(!geometry) {
        geometry =  feature.getGeometry()
    }

    setActiveMutationGeometry(geometry, projectionFrom, projectionTo, type)
}

export function getDrawModify() {
    return modify
}

export function undoDrawGeometry() {
    olDraw.removeLastPoint()
}

export function appendDrawCoordinates(coordinates) {
    olDraw.appendCoordinates([coordinates])
}

export function finishDrawing() {
    olDraw.finishDrawing()
}

export function getDrawPointerCount() {
    if(olDraw) {
        return olDraw.getProperties()
    }
    return 0
}

export function toggleDrawButtons(disable = true) {
    const drawButtons = getAllBySelector('ol-draw-geometry')
    drawButtons.forEach((drawButton) => {
        const element = drawButton.querySelector('input')
        if(element.value !== 'FromMap') {
            drawButton.querySelector('input').disabled = disable
            const slcMutationSnapLayer = getBySelector('#slcMutationSnapLayer')
            if(slcMutationSnapLayer) {
                slcMutationSnapLayer.disabled = disable
            }

            const btnMutationSnapLayer = getBySelector('#btnMutationSnapLayer')
            if(btnMutationSnapLayer) {
                btnMutationSnapLayer.disabled = disable
            }

            const btnMutationUndoLayer = getBySelector('#btnMutationUndoLayer')
            if(btnMutationUndoLayer) {
                btnMutationUndoLayer.disabled = disable
            }
            if(disable) {
                showElementsBySelector('#divDrawIn3DNotification')
            } else {
                hideElementsBySelector('#divDrawIn3DNotification')
            }
        }
    })
}
